import { ManualInputUpdateDto, CoreListElement, DynamicExcelParam, ErrorList, ManualInputDynamicTablePrams, ManualIds, MIds } from './../../models/manualinput/ManualInput';
import { DynamicTablesWithCaptions, ManualInputDataUpdate, DyanmicInputUpdate, ManualInputStatus } from './../../models/manualinput/DataSetting';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/services/base.service';
import { Observable } from 'rxjs';
import { DataSettingsOutput } from 'src/app/models/manualinput/DataSetting';
import { FilePathCollection } from 'src/app/models/file/file-collection';
import { ReturnFlag } from 'src/app/models/return-flag';

@Injectable({
    providedIn: 'root'
})

export class ManualInputService {

    constructor(private baseService: BaseService) { }

    GetSchemaLst(): Observable<DataSettingsOutput> {
        let url = `forecast/GetSchemaLst`;
        return this.baseService.get(url);
    }

    GetTableLst(SchemaName: string = ''): Observable<DataSettingsOutput> {
        let url = `forecast/GetTableLst?SchemaName=` + SchemaName;
        return this.baseService.get(url);
    }

    GetTableDet(selectedschema: string = '', selectedtable: string = ''): Observable<DataSettingsOutput> {
        let url = `forecast/GetTableDet?obj.schemaName=${selectedschema}&obj.tableName=${selectedtable}`;
        return this.baseService.get(url);
    }

    getDynamicTableData(): Observable<DynamicTablesWithCaptions> {
        const url = `manualInput/GetDynamicTableData`;
        return this.baseService.get(url);
    }

    getDynamicTableDataForEditing(dynamicTableId: number, ids: MIds = { Id: [] }): Observable<ManualInputUpdateDto> {
        const url = `manualInput/GetDynamicTableDataForUpdate`;
        let updateItemIds: ManualIds = { Ids: ids, dynamicTableId: dynamicTableId };
        return this.baseService.post(url, updateItemIds);
    }



    getListDataSourceForField(listIds: number[]): Observable<CoreListElement[]> {

        const url = `manualInput/GetListDataSourceForField`;
        return this.baseService.post(url, listIds);
    }

    updateManualInputs(inputs: ManualInputDynamicTablePrams[]): Observable<any> {
        const url = `manualInput/UpdateManualInputs`;
        return this.baseService.post(url, inputs);
    }

    addManualInput(inputs: ManualInputDynamicTablePrams): Observable<number> {
        const url = `manualInput/AddManualInput`;
        return this.baseService.post(url, inputs);
    }

    deleteManualInputs(ids: ManualIds = { dynamicTableId: 0, Ids: { Id: [] } }): Observable<any> {
        const url = `manualInput/DeleteManualInputs`;
        return this.baseService.post(url, ids);
    }

    // deleteManualInputs(inputs: ManualInputDynamicTable[]): Observable<any> {
    //     const url = `manualInput/DeleteManualInputs`;
    //     return this.baseService.post(url, inputs);
    // }

    ValidateManualInputs(fileName: DynamicExcelParam, type: boolean): Observable<ErrorList[]> {
        let url = `manualInput/ValidateManualInputsFile`;
        if (type) {
            url = `manualInput/ValidateManualInputsFileDb`;
        }
        return this.baseService.post(url, fileName);
    }

    UploadDynamicData(fileName: DynamicExcelParam, type: boolean): Observable<ErrorList[]> {
        let url = `manualInput/uploadDynamicData`;
        if (type) {
            url = `manualInput/uploadDynamicDataDb`;
        }
        else {
            fileName.uniqueId = "";
        }
        return this.baseService.post(url, fileName);
    }

    SavePage(files: File[] = []): Observable<Object> {
        const formData = new FormData();


        for (let file of files) {
            formData.append("files", file);
        }

        return this.baseService.postFormData("FileUpload/UploadTemp1", formData);
    }

    DownloadFile(fileName: FilePathCollection): Observable<File> {
        const url = `FileUpload/GetBlobDownload?Type=` + fileName.LinkType + '&FileName=' + encodeURIComponent(fileName.FileName);
        return this.baseService.getBlob(url);
    }

    getDynamicTableDataUpdate(): Observable<ManualInputDataUpdate> {
        const url = `manualInput/LoadDataManualInputs`;
        return this.baseService.post(url);
    }

    ReloadDataManualInputs(showLoadingIndicator: boolean = true): Observable<ManualInputStatus[]> {
        const url = `manualInput/ReloadDataManualInputs`;
        return this.baseService.post(url, null, { showLoadingIndicator: showLoadingIndicator, showErrorNotification: false });
    }

    RunManualInputs(id: any, isWait: any): Observable<ReturnFlag> {
        const url = `manualInput/RunManualInputs?id=` + id + '&isWait=' + isWait;
        return this.baseService.post(url);
    }

    StopTaskDataManualInputs(id: any): Observable<ReturnFlag> {
        const url = `manualInput/StopTaskDataManualInputs?id=` + id;
        return this.baseService.post(url);
    }

    UpdateDynamicObject(data: DyanmicInputUpdate): Observable<ReturnFlag> {
        const url = `manualInput/UpdateDynamicObject`;
        return this.baseService.post(url, data);
    }

    exportExcel(data: DyanmicInputUpdate): Observable<ReturnFlag> {
        const url = `manualInput/ExportDynamicObject`;
        return this.baseService.post(url, data);
    }

    SelectDynamicTableHelpId(dynamicTableId: number): Observable<any> {
        const url = `manualInput/SelectDynamicTableHelpId`;
        return this.baseService.post(url, dynamicTableId);
    }
}
